"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class represents workflow's action with expression
 */
var ActionWithExpressionDto = /** @class */ (function () {
    function ActionWithExpressionDto(action, expression, rolePermissionExpressions) {
        this._action = action;
        this._expression = expression;
        this._rolePermissionExpressions = rolePermissionExpressions;
    }
    ActionWithExpressionDto.prototype.getAction = function () {
        return this._action;
    };
    ActionWithExpressionDto.prototype.getExpression = function () {
        return this._expression;
    };
    ActionWithExpressionDto.prototype.getRolePermissionExpressions = function () {
        return this._rolePermissionExpressions;
    };
    return ActionWithExpressionDto;
}());
exports.ActionWithExpressionDto = ActionWithExpressionDto;
//# sourceMappingURL=action-wth-expression.dto.js.map